
import { ekanalys_ekanalys_columns } from '../../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import EkonomiskAnalysEditColumnCaptionQuery from '../Queries/EkonomiskAnalysEditColumnCaptionQuery/EkonomiskAnalysEditColumnCaptionQuery';
import { EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns } from '../../../../../../../Queries/EkonomiskAnalysColumnCaptionQuery/_QueryTypes/EkonomiskAnalysColumnCaptionQuery';
import { getColumnName } from '../../../../../../../Queries/EkonomiskAnalysColumnCaptionQuery/EkonomiskAnalysColumnCaptionQuery';
import { INewColumnData } from '../EkonomiskAnalysEditColumnDialog/EkonomiskAnalysEditColumnDialog';
import EkonomiskAnalysEditColumnAutosuggest from './EkonomiskAnalysEditColumnAutosuggest';
import { ISuggestion } from '../../../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';

interface IProps {
  column?: ekanalys_ekanalys_columns;
  newColumnData: INewColumnData;
  standardColumns?: ekanalys_ekanalys_columns[];
  columnChange: (newValue: string | null) => void;
}

const getCaption = (
  column: EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns
): ISuggestion => {
  return { name: getColumnName(column), value: getFaltkod(column) };
};

const getFaltkod = (
  column: EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns
): string => {
  if (column.fieldinfo) {
    const faltkod = column.fieldinfo.find(x => x.name === 'FALTKOD');
    if (
      faltkod &&
      faltkod.value &&
      faltkod.value.__typename === 'TEDMixedString'
    ) {
      return faltkod.value.asString || '';
    }
    return '';
  }
  return '';
};

const EnhancedEkonomiskAnalysEditColumnTitleField: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const onBlur = (value: string) => {
    if (value !== '') {
      props.columnChange(value);
    }
  };
  return (
    <EkonomiskAnalysEditColumnCaptionQuery
      columns={props.standardColumns}
      newColumnData={props.newColumnData}
    >
      {({ columns, loading }) => {
        const captions = columns ? columns.map(getCaption) : [];
        return !loading ? (
          <EkonomiskAnalysEditColumnAutosuggest
            label="Kolumnrubrik"
            value={props.column ? props.column.FALTKOD || '' : ''}
            onChange={props.columnChange}
            onBlur={onBlur}
            touched={true}
            fieldErrors={undefined}
            suggestions={captions}
            fullWidth
          />
        ) : (
          <></>
        );
      }}
    </EkonomiskAnalysEditColumnCaptionQuery>
  );
};

export default EnhancedEkonomiskAnalysEditColumnTitleField;
